import { sendAxiosRequest } from '../../utils/sendRequest';
import IResponse from '../../../models/responces/IResponse';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IDataObject from '../../../models/restful/IDataObject';
import IDataObjectParams from '../../../models/params/IDataObjectParams';

export interface ICRUDUpdateParams {
  dataObjectName: string;
  dataObject: IDataObject;
  dataObjectParams?: IDataObjectParams;
}
const apiUpdate = (params: ICRUDUpdateParams) =>
  sendAxiosRequest({
    method: 'put',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'crud',
      id: params.dataObject.ID,
      dataObjectName: params.dataObjectName,
      dataObjectParams: params.dataObjectParams || undefined
    }),
    data: params.dataObject,
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IResponse>;
export default apiUpdate;
